import { Button, Form, Modal } from "react-bootstrap"
import i18next from "i18next"
import _ from 'lodash';
import { MdOutlineWarningAmber } from "react-icons/md";
import { createPortal } from 'react-dom';

type Props = {
  isOpen?: boolean;
  closeModal?: (reload?: boolean) => void;
  doDelete: () => void;
}

const DeleteOptionalModal: React.FC<Props> = ({ isOpen, doDelete, closeModal = _.noop }) => {

  const onClose = () => {
    closeModal();
  }

  return createPortal(<Modal show={isOpen} backdrop="static" keyboard={false} backdropClassName="modal-upfront">
    <Modal.Body className="text-center">
      <div className="mb-3">
        <MdOutlineWarningAmber size={44} />
      </div>
      {i18next.t('unquotable_optional_confirmation_message')}
    </Modal.Body>
    <Modal.Footer>
      <Button variant='link' onClick={onClose}>
        {i18next.t('cancel')}
      </Button>
      <Button onClick={() => doDelete()}>
        {i18next.t('make_it_unquotable')}
      </Button>
    </Modal.Footer>
  </Modal>, document.body)
}

export default DeleteOptionalModal;
